// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"9513d4f4","906":"5e80b331","948":"211d3956"}[chunkId] + ".chunk.css";
};